<!-- WHAT: A copy of CsDashboards_ArefVersion2.vue to be modified for the List Services -->
<!-- HISTORY:
   V260526.1: Added Kushal to the isPowerAdmin property as well.
   V260512.1: Set the cs-api-service prop of the BtChart component for filters.
   V260323.1: In saveDashboard(), added validations to ensure that each chart does not exceed its max number of metrics and that the total metrics in the dashboard do not exceed the limits specified in the Settings.
   V260320.1: Read newly implemented settings and passed dashboardsLabels to BtChart instead of chartsSettings + Modified adjustModel() by passing timezone to calculate event_date range accordingly.
   V260313.2: Modified chartClicked() to ignore the filter prop when the destination component already contains filters or a whereClause + Made chartColors dropdown accessible only to the Power Admin.
   V260310.1: Sorted dashboardList.
   V260305.1: [not sent to RF] Made the Edit switch accessible to me as well.
   V260227.1: Made the Create button accessible only to the Power Admin and Edit switch to the dashboard's owner.
   V260226.1: Parsed the token to pass the aid to the BtChart component.
   V260223.1: Regarding CalculatedTable, fixed a bug that added extra 'and' in whereClause, and
      Implemented new business logic to handle cell clicks (instead of row click).
   V260203.1: In adjustModel(), added logic to update the model’s lake property based on the selected date range.
   V260105.2: In GlobalFilters class, added defaultId for DatePicker.
   V251205.1: [not sent to RF] Removed Global Chart Colors dropdown if the dashboard didn't have any charts (Added globalColorsNeeded computed).
   V251204.1: Consumed debug and is-admin-user props of BtChart + In edit mode, disable the Dashboards dropdown.
   V251120.1: Added getImportHeaders() for PaginatedTable + Fixed Generate PDF issue + Disable dashboards dropdown in edit mode +
      Consumed can-toggle prop + Introduced cleanDashboard() to be called before save/update + Due to having 2 api services, set their names accordingly.
   V251104.1: Supported chart-click events + Hid UPDATE, DISCARD CHANGES & GENERATE PDF buttons in edit mode +
      Fixed the UPDATE btn permission and other issues + Added Global Dashboard Colors dropdown.
   V251027.2: 1st release.
-->
<!-- TODO:
   -  In chartClicked()), filter metrics' whereClause values will not be injected into the destination cell if it already has its own filter/whereClause defined.
   - In Create new dashboard, bypass getDashboards() and getDashboard() methods (this function is partially required). Instead, get the _id and add it to the list cause the rest already exists.
   - Improve rendering for Generate PDF.
   - Why discard changes btn is not shown when colors are changed.
   - Check adjustModel for to-do (currently line# 1030)
   - Enhance chart-click for models w/filter (DateMetrics & Histogram) + pivotColumn (DimsDim & Date-Dim).
   - Fix the bug that keeps SAVE btn in configureChart enabled (perhaps stringify being sorted).
   - Make sure dateField of gf date is not used in date models.
   - Watch schemas contents: {column_name:'', column_type:'', null: YES, key: null, default: null, extra: null}
   - Check Query page for the model changes
   - IMPORTANT: Dropdown change causing that getData() for the dropdown is called: Maybe watch model instead of filter?
   - dateColumn of DatePickers cannot exist in other elements (gf or chart)
   - originalModel is saved after each datePicker changes.
   - Set col size based on the existing cells (i.e., if 1 cell is 4, set new cell to 8)
   - For blank dashboard, cellType='dp'. otherwise, set cellType to 'c'
   - Keeping the last dropdown items or to have the 1st item preselected
-->
<!-- BUSINESS LOGIC:
   3/13/26: Dice/Slice logic in models with filter:
      - When such a model is clicked, the filter is passed but is only applied to models that do not already have a filter/WhereClause.
         This is because injecting such a filter would require parsing both the source and destination clauses.   2/24/26 - Dice/Slice logic in general:
      - When a new click occurs on a chart, slicing is applied to the original models, not to previously sliced ones.
   2/20/2026 - Dice/Slice logic in the case of Calculated Table (which can have filter with exclude flag):
      1. Date range should be eliminated/ignored for drill down (Paginated Table) of excluded metrics.
      2. For charts or not-excluded metrics, we will keep the destination date range.
   How to adjust *-metric models:
   - If there is a filter with excluded switch true, event_date adjustment will only applies to the filters with excluded false. whereClause won't be changed.
   - If there is no excluded filters or it's dice & slice, all adjustments will happen in whereClause.
-->
<template>
<v-container fluid class="px-3 py-3">
   <v-card class="pb-2">
      <v-card-title>
         <h1 class="title font-weight-bold grey--text darken-4 pl-2" style="color:#757575 !important">
            <v-icon class="pr-1">dashboard</v-icon>
            <span>Dashboards</span>
         </h1>
      </v-card-title>

      <v-card-text>
         <v-row v-if="errMsg" class="py-0">
            <v-col cols="12" class="pt-4">
               <v-alert dense outlined class="mb-0"
                  type="error"
               >{{errMsg}}</v-alert><!-- -{{parquetFilesSet?.size}} -->
            </v-col>
         </v-row>

         <template v-if="parquetFilesSet?.size > 0">
            <v-row align="center" class="pl-3" justify= "start">  
               <v-col cols="12" md="3" class="pt-0" v-show="canView">
                  <v-autocomplete dense persistent-hint single-line
                     item-text="name"
                     item-value="_id"
                     :disabled="isEditing"
                     :items="dashboardList"
                     :hint="`* Dashboards: ${dashboardList.length}`"
                     :placeholder="dashboardsPlaceholder"
                     v-model="selectedDashboard"
                     @change="dashboardChanged"
                  ></v-autocomplete>
               </v-col>
               <!-- :class="isDesktop ? 'd-flex justify-center align-center' : ''" -->
               <v-col cols="12" md="1" v-show="canEdit">
                  <v-switch
                     label="Edit"
                     v-model="isEditing"
                     @change="editSwitchChanged"
                  ></v-switch>
               </v-col> 
               <v-col cols="12" md="1" v-show="canUpdate && !isEditing"><!--&& canSave -->
                     <!-- :btn-disabled="!isDashboardValid" -->
                  <bt-dashboard-save
                     btn-icon-left="save"
                     btn-role="save"
                     btn-title="Update"
                     :submit-func="saveDashboard"
                     v-model="ddl"
                     @submit="dashboardSaved"
                  />
               </v-col>
               <v-col cols="12" md="2" v-show="isDashboardEdited && !isEditing">
                  <v-btn small
                     color="error"
                     @click="discardChanges"
                  >Discard Changes</v-btn>
               </v-col>
               <v-col cols="12" md="1" v-show="canCreate && !isEditing && !isDashboardEdited">
                  <bt-dashboard-save
                     btn-icon-left="add"
                     btn-role="saveas"
                     btn-title="Create"
                     btn-color= "warning"
                     :confirm-message="newConfirmMsg"
                     :submit-func="saveNewDashboard"
                     v-model="ddlNew"
                     @submit="dashboardCreated"
                  />
               </v-col>
               <v-col cols="12" md="1" v-show="canSaveAs && !isEditing && !isDashboardEdited">
                  <bt-dashboard-save
                     btn-icon-left="content_copy"
                     btn-role="saveas"
                     btn-title="Clone"
                     btn-color= "success"
                     :submit-func="saveAsDashboard"
                     v-model="ddl"
                     @submit="dashboardCreated"
                  />
               </v-col>
               <v-col cols="12" md="1" v-show="canDelete && !isEditing && !isDashboardEdited">
                  <!-- :confirm-message="deleteConfirmMsg" -->
                  <bt-dashboard-save
                     btn-icon-left="delete"
                     btn-role="delete"
                     btn-title="Delete"
                     btn-color= "error"
                     :submit-func="deleteDashboard"
                     v-model="ddl"
                     @submit="dashboardDeleted"
                  ></bt-dashboard-save>
               </v-col>
               <v-spacer></v-spacer>
               <template v-if="!isEditing">
                  <!-- V260313.2: added if condition -->
                  <v-col cols="12" md="3" v-if="isPowerAdmin">
                     <v-select v-if="globalColorsNeeded"
                        dense hide-selected persistent-hint required
                        class="pt-0 pr-5"
                        hint="Global Chart Colors"
                        :items="chartColorsItems"
                        :rules="[rules.required]"
                        v-model="dashboard.chartColors"
                        @change="chartColorsChanged"
                     ></v-select>
                  </v-col>
                     <!-- :class="isDesktop ? 'd-flex justify-end' : ''" -->
                  <v-col cols="12" md="1" v-if="ddl.definition"
                     :class="isDesktop ? 'd-flex justify-end' : ''"
                  >
                     <v-btn small
                        @click="generatePdf"
                     >Generate PDF</v-btn>
                  </v-col>
               </template> 
            </v-row> 

            <!-- :class="{ 'no-transitions': disableTransitions }" -->
            <!-- <div
               id="element-to-convert"
            > -->
            <div class="pdf-wrapper">
            <v-container fluid class="px-0 pt-0 pb-5">
               <v-row>
                  <v-col v-for="(gf, gfIndex) in dashboard.globalFilters" :key="gfIndex"
                     cols="12" :md="gf.cols"
                  >
                     <v-card class="pb-0">
                        <v-card-text class="pt-0 pb-0 px-0">
                              <!-- :data="gf?.data || undefined" -->
                              <!-- :charts-settings="chartsSettings" -->
                              <!-- V260512: consumed ca-api-service -->
                           <bt-chart
                              :aid="jwt.aid"
                              :col-size="gf.cols"
                              :cs-api-service="csApiService"
                              :date-picker-columns="getDatePickerColumns(gf.filter)"
                              :debug="debug"
                              :error-message="gf.errorMessage"
                              :filter-index="gfIndex"
                              :is-editing="isEditing"
                              :is-filter="true"
                              :is-ready="allFiltersApplied"
                              :lake="lake"
                              :ls-api-service="lsApiService"
                              :sliced-data="gf.slicedData"
                              :schemas="schemas"
                              v-model="gf.filter"
                              @chart-save="gfSaved(gf, gfIndex)"
                              @model-change="gfModelChanged(gf, gfIndex)"
                              @date-change="dateChanged(gf.filter.dateColumn, gfIndex, ...arguments)"
                              @dropdown-change="dropdownChanged(gf.filter.model.column, gfIndex, ...arguments)"
                              @data-change="dropdownDataChanged(gfIndex, ...arguments)"
                           ></bt-chart>
                        </v-card-text>

                        <v-card-actions v-if="isEditing">
                           <v-row class="py-0">
                              <v-col cols="12" md="5" class="pt-2 pb-0">
                                 <v-icon v-if="gfIndex > 0"
                                    @click="filter_delete(gfIndex)"
                                 >delete_forever</v-icon>
                                 <!-- gf.filter.filterType === 'DatePicker' ||  -->
                                  <!-- v-show="gf.filter.filterType != 'DatePicker'" -->
                                    <!-- :disabled="12 - gfSumCols < minFilterColSize" -->
                                 <v-icon v-show="dashboard.globalFilters.length < maxFilters"
                                    @click="filter_copy(gfIndex)"
                                 >file_copy</v-icon>
                                    <!-- :disabled="12 - gfSumCols < minFilterColSize" -->
                                 <v-icon v-show="gfIndex === dashboard.globalFilters.length - 1 && dashboard.globalFilters.length < maxFilters"
                                    @click="filter_add(gfIndex)"
                                 >add</v-icon>
                                 <v-icon v-show="gfIndex > 1"
                                    @click="filter_left(gfIndex)"
                                 >keyboard_arrow_left</v-icon>
                                 <v-icon v-show="gfIndex > 0 && gfIndex < dashboard.globalFilters.length - 1"
                                    @click="filter_right(gfIndex)"
                                 >keyboard_arrow_right</v-icon>
                              </v-col>
                              <v-col cols="12" md="7" class="pt-2 pb-0 pl-0">
                                    <!-- thumb-label="always" -->
                                    <!-- :max="12 - gfSumCols >= minFilterColSize ? 12 - gfSumCols : gf.cols" -->
                                 <v-slider ticks thumb-label
                                    :max="maxFilterColSize"
                                    :min="minFilterColSize"
                                    step="1"
                                    tick-size="4"
                                    v-model="gf.cols"
                                 />
                              </v-col>
                           </v-row>
                        </v-card-actions>
                     </v-card>
                  </v-col>
               </v-row>
            <!-- </v-container> -->

            <!-- <v-container fluid class="px-0 py-0"> -->
               <v-row v-for="(r, rIndex) in dashboard.layout" :key="rIndex">
                  <v-col cols="12" :md="c.cols" v-for="(c, cIndex) in r" :key="cIndex">
                     <v-card class="pb-0">
                        <v-card-text class="pt-0 pb-0 px-0">
                              <!-- :data="c.data || undefined" -->
                              <!-- :charts-settings="chartsSettings" -->
                           <bt-chart
                              :aid="jwt.aid"
                              :bt-helpers="btHelpers"
                              :can-toggle="c.chart.chartType?.endsWith('Chart')"
                              :col-size="c.cols"
                              :cs-api-service="csApiService"
                              :dashboards-labels="dashboardsSettings.labels"
                              :debug="debug"
                              :error-message="c.errorMessage"
                              :global-chart-colors="dashboard.chartColors"
                              :is-admin-user="isAdminUser"
                              :is-editing="isEditing"
                              :is-filter="false"
                              :is-ready="allFiltersApplied"
                              :lake="lake"
                              :ls-api-service="lsApiService"
                              :sliced-data="c.slicedData"
                              :schemas="schemas"
                              v-model="c.chart"
                              @model-change="chartModelChanged(c)"
                              @chart-click="chartClicked(rIndex, cIndex, ...arguments)"
                              @chart-reclick="chartReclicked(rIndex, cIndex)"
                              @chart-export="exportCreated"
                              @get-import-headers="getImportHeaders"
                           ></bt-chart>
                        </v-card-text>

                        <v-card-actions v-if="isEditing">
                           <v-row class="pt-4">
                              <v-col cols="12" md="5" class="pt-2 pb-0">
                                 <v-icon
                                    :disabled="dashboard.layout.flat().length === 1"
                                    @click="cell_delete(rIndex, cIndex)"
                                 >delete_forever</v-icon>
                                 <v-icon @click="cell_copy(rIndex, cIndex)">file_copy</v-icon>
                                  <!-- && 12 - getChartsSumCols(rIndex) >= minChartColSize -->
                                 <v-icon v-show="cIndex == r.length - 1"
                                    @click="cell_add(rIndex, cIndex)"
                                 >add</v-icon>
                                 <v-icon @click="cell_left(rIndex, cIndex)" v-show="cIndex > 0">keyboard_arrow_left</v-icon>
                                 <v-icon @click="cell_right(rIndex, cIndex)" v-show="cIndex < r.length - 1">keyboard_arrow_right</v-icon>
                                 <v-icon @click="cell_down(rIndex, cIndex)" v-show="rIndex < dashboard.layout.length - 1">keyboard_arrow_down</v-icon>
                                 <v-icon @click="cell_up(rIndex, cIndex)" v-show="rIndex > 0">keyboard_arrow_up</v-icon>
                                 <v-icon @click="cell_return" v-show="cIndex == r.length - 1 && rIndex == dashboard.layout.length - 1">keyboard_return</v-icon>
                              </v-col>
                              <v-col cols="12" md="7" class="pt-2 pb-0 pl-0">
                                 <v-slider v-show="isEditing" thumb-label ticks
                                    max="12"
                                    min="4"
                                    step="1"
                                    tick-size="4"
                                    v-model="c.cols"
                                 />
                              </v-col>
                           </v-row>
                        </v-card-actions>
                     </v-card>
                  </v-col>
               </v-row>
            </v-container>
            </div>
            <!-- </div> -->
         </template>
      </v-card-text>
   </v-card>
</v-container>
</template>

<script>
import BtChart from './BtChartForLS.vue';
import BtDashboardSave from './BtDashboardSave.vue';
import html2pdf from "html2pdf.js";
import { APIService as LsAPIService } from '../services/ls-api-service.js';
import { APIService as CsAPIService } from '../services/cs-api-service.js';
import { BtHelpers } from '../services/bt-helpers.js';
import { deepClone, getUTCFromDate, getUTCToDate, isLocal, sortedStringify, sortArray } from '../mixins/bt-mixin.js';
import { format, addDays, addMonths, startOfDay, startOfMonth, endOfMonth } from "date-fns";
import { mapGetters } from 'vuex';

const NAME = 'LsDashboards';
const EVENT_DATA_REGEX = /event_date\s+between\s+'[^']+'\s+and\s+'[^']+'/i;

// V260223
function _mergeWhereAndFilter(whereClause = '', filter = '', exclude = false) {
   // alert('in _mergeWhereAndFilter(): whereClause=' + whereClause + '\nfilter=' + filter + '\nexclude=' + exclude);
   whereClause = whereClause?.trim() || '';
   filter = filter?.trim() || '';

   if (!whereClause) return filter;
   if (!filter) return whereClause;

   let eventDateCondition = '';
   whereClause = whereClause.replace(/^where\s+/i, '');

   // Extract from whereClause
   const whereMatch = whereClause.match(EVENT_DATA_REGEX);
   if (whereMatch) {
      eventDateCondition = whereMatch[0];
      if (exclude) {
         whereClause = whereClause.replace(EVENT_DATA_REGEX, '')
            .trim()
            .replace(/^and\s+/i, '');      
      }
   }

   filter = filter.replace(/^where\s+/i, '');
   if (!exclude) {
      const filterMatch = filter.match(EVENT_DATA_REGEX);
      if (filterMatch) {
         filter = filter.replace(filterMatch[0], '').trim();
         if (!eventDateCondition)
            eventDateCondition = filterMatch[0];
      }
   }
   filter = filter.replace(/^and\s+/i, '');

   // Extract from filter
   // if (!exclude) {
   //    const filterMatch = filter.match(eventDateRegex);
   //    if (filterMatch) {
   //       filter = filter.replace(eventDateRegex, '').trim();
   //       if (filter.startsWith('and '))
   //          filter = filter.slice(4).trim();
   //    }
   // }

   // Remove leading "where" from filter if exists
   // filter = filter.replace(/^where\s+/i, '');

   // Clean possible dangling "where and"
   // whereClause = whereClause.replace(/where\s+and\s+/i, 'where ');

   let combined = whereClause;

   if (filter) {
      // combined += (combined ? ' and ' : 'where ') + filter;
      combined += (combined ? ' and ' : ' ') + filter;
   }

   // if (!exclude && eventDateCondition && !combined.includes(eventDateCondition))
   //    combined = eventDateCondition + (combined ? ' and ' + combined : '') + ;

   if (combined)
      combined = 'where ' + combined;

   return combined;

   // ✅ Only add event_date back if NOT excluded
   // if (!exclude && eventDateCondition) {
   //    const cleanCombined = combined.replace(/^where\s+/i, '');
   //    return `where ${eventDateCondition}${cleanCombined ? ' and ' + cleanCombined : ''}`;
   // }

   // return combined.replace(/\s+and\s+and\s+/gi, ' and ');
}

class GlobalFilter {
   constructor(cols, ind) {
      this.cols = cols || 4;
      this.filter = {
         ...(!ind && {
            filterType: 'DatePicker',
            title: 'Event Date',
            dateColumn: 'event_date',
            defaultId: 'TY'
         }),
         isTypeEditable: !!ind
      };
      this.data = [];
   }
}

class Layout {
   constructor(cols) {
      this.cols = cols || 12;
      this.chart = {};
      this.data = [];
   }
}

export default {
   name: NAME,

   components: {
      BtChart,
      BtDashboardSave
   },

   props: {
      debug: {
         type: Boolean,
         default: false
      },

      isActualEndpoint: {
         type: Boolean,
         default: true
      }
   },

   data() {
      return {
         isLocal,
         chartColorsItems: [
            // #3366CC,#DC3912,#FF9900,#109618,#990099,#3B3EAC,#0099C6,#DD4477,#66AA00,#B82E2E,#316395,#994499,#22AA99,#AAAA11,#6633CC,#E67300,#8B0707,#329262,#5574A6,#3B3EAC
            { text: "Watery Blue-Greens", value: "#003b46,#07575b,#66a5ad,#c4dfe6"},
            { text: "Exotic & High-Impact", value: "#0f1f38,#8e7970,#f55449,#1b4b5a"},
            { text: "Fresh Greens", value: "#265c00,#68a225,#b3de81,#b3de99"},
            { text: "Crisp & Dramatic", value: "#505160,#68829e,#aebd38,#598234"},
            { text: "Day & Night", value: "#011a27,#063852,#f0810f,#e6df44"},
            { text: "Spicy Neutrals", value: "#af4425,#662e1c,#ebdcb2,#c9a66b"},
            { text: "Golden Afternoon", value: "#882426,#cdbea7,#323030,#c29545"}
         ],
         rules: {
            required: value => !!value || "Value is required!"
         },
         maxFilters: 4,
         minFilterColSize: 3,
         minChartColSize: 4,
         lsApiService: null,
         csApiService: null,
         btHelpers: null,
         parquetFilesSet: null,
         distinct: false,
         // chartsSettings: {},
         dashboardsSettings: {},
         // resetBtnDisabled: true,
         isEditing: false,
         fieldValues: {},
         importHeaders: null, //[]
         selectedHeaders: [],
         chart: {},
         dashboard: { layout: [[]] },
         selectedDashboard: 0,
         dashboardList: [],
         ddl: {},
         ddlNew: {},
         ddlAuthor: '',
         errMsg: '',
         lake: {},
         schemas: [],
         // deleteConfirmMsg:'Are you sure you want to delete your current dashboard?\nTHIS ACTION CANNOT BE UNDONE.',
         allFiltersApplied: false,
         isDashboardEdited: false,
         jwt: {}
         // disableTransitions: false
         // isDashboardValid: true
      };
   },

   computed: {
      ...mapGetters(['token', 'user']),

      isDesktop() {
         return this.$vuetify.breakpoint.mdAndUp;
      },

      userEmail() {
         return this.user.email?.trim().toLowerCase() || '';
      },

      userPolicies() {
         return this.user.policies || [];
      },

      lsDashboards() {
         return this.user.preferences?.lsDashboards || [];
      },

      // V260526: Added Kushal
      isPowerAdmin() {
         return this.user.isPowerAdmin || this.userEmail === 'kdutta@mindfireinc.com';
      },

      isPowerUser() {
         return this.user.isPowerUser;
      },

      isAdminUser() {
         return this.user.isAdminUser;
      },

      canView() {
         return this.userPolicies.includes('contact-dashboards-view');
      },

      canEdit() {
         return this.ddlAuthor === this.userEmail || isLocal;  //V260305: added ||
      },

      canUpdate() {
         return this.ddlAuthor === this.userEmail && this.userPolicies.includes('contact-dashboards-update');
      },

      canCreate() {
         //V260227: return this.userPolicies.includes('contact-dashboards-create');
         return this.isPowerAdmin;
      },

      // canSave() { //TODO:
      //    return this.ddlAuthor === this.userEmail && this.userPolicies.includes('contact-dashboards-update');
      // },

      canSaveAs() {
         return !!this.ddlAuthor && this.canCreate;
      },

      canDelete() {
         return this.ddlAuthor === this.userEmail && this.userPolicies.includes('contact-dashboards-delete');  //TODO: && this.dashboardList.length > 1;
      },

      dashboardsPlaceholder() {
         if (this.errMsg) return 'something went wrong!';
         else if (this.dashboardList.length) return "select a dashboard...";
         else return "you haven't created any dashboards yet!";
      },

      maxFilterColSize() {
         return 12 / this.dashboard?.globalFilters.length || 12;
      },

      // gfSumCols() {
      //    const sum = this.dashboard.globalFilters.reduce((sum, item) => {
      //       return sum + Number(item.cols || 0);
      //    }, 0);
      //    return sum;
      // },

      newConfirmMsg() {
         return this.isDashboardEdited ? 'This action will discard your current changes.\nAre you sure?' : undefined;
      },

      dateColumns() {
         return this.schemas?.filter(col => col.column_type === 'TIMESTAMP' || col.column_type === 'DATE')
            .map(col => col.column_name) || [];
      },

      //V251205: To find out if Global Chart Colors dropdown should be shown or not.
      globalColorsNeeded() {
         for (let i = 0; i < this.dashboard?.layout?.length; i++) {
            const row = this.dashboard.layout[i];
            for (let j = 0; j < row.length; j++) {
               const cell = row[j];
               if (cell.chart?.chartType?.endsWith('Chart'))
                  return true;
            }
         }
         return false;
      }
   },

   watch: {
      token: {
         immediate: true,
         handler() {
            this.init();
         }
      },

      // dashboard: {
      //    // immediate: true,
      //    deep: true,
      //    handler (val) {
      //       alert('dashboard=' + JSON.stringify(val));
      //       // this.resetBtnDisabled = !val.resetFilters;
      //    }
      // },

      // V260320
      // chartsSettings: {
      //    deep: true,
      //    handler () {
      //       this.dashboardChanged();
      //    }
      // }
   },

   methods: {
      log(msg, _alert =false) {
         if (this.debug) {
            console.log(`-----${NAME} V260526.1 says => ${msg}`);
            if (_alert) {
               alert(`${NAME} says:\n${msg}`);
            }
         }
      },

      logout() {
         this.$router.push('/');
      },

      async init() {
         this.importHeaders = [];
         this.dashboardList = [];
         this.ddl = {};
         this.dashboard = {};
         this.ddlAuthor = '';

         if (this.token) {
            // V260226: to get the aid and pass it to BtChart
            this.jwt = JSON.parse(Buffer.from(this.token.split('.')[1], 'base64'));
            this.lsApiService = new LsAPIService(null, this.token, this.debug, this.isActualEndpoint);
            this.csApiService = new CsAPIService(null, this.token, this.debug, this.isActualEndpoint);
            this.btHelpers = new BtHelpers(this.token, true, true);
            await this.getSettings();
            await this.getParquetFiles();
            if (this.parquetFilesSet.size) {
               await this.getDashboards();
            }
         }
      },

      async getParquetFiles() {
         const available = new Set();
         let result = await this.lsApiService.getLakeDirectories();
         if (result.logout)
            this.logout();
         else if (result.message) {
            this.lakeTree = [];
            // this.errMsg = result.message;
         } else {
            this.lakeTree = result.data;
         }

         for (const yearNode of this.lakeTree) {
            const year = yearNode.name;
            if (!yearNode.children) continue;

            for (const monthNode of yearNode.children) {
               const month = monthNode.name;
               const files = monthNode.children || [];
               const hasParquet = files.some(file => file.name.endsWith('.parquet'));
               if (hasParquet) {
                  available.add(`${year}/${+month}`); // normalize month like 7 instead of "07"
               }
            }
         }

         this.errMsg = available?.size ? '' : 'There is no schemas available. Please create one or more ETLs to upload some files.';
         this.parquetFilesSet = available;

         // alert(JSON.stringify(Array.from(this.parquetFilesSet)));
         this.lake = {
            year: Array.from(this.parquetFilesSet).join(','),
            month: '|',
            fileFormat: 'parquet'
         };

         result = await this.lsApiService.getSchemas(this.lake);
         if (result.logout)
            this.logout();
         else if (result.message) {
            this.schemas = [];
            this.errMsg = result.message;
         } else {
            this.schemas = result.data;
         }

      },

      async getDashboards(ddl) {
         const result = await this.lsApiService.getDashboards();
         if (result.logout) this.logout();
         else if (result.message) {
            this.errMsg = result.message;
            return;
         }

         let dashboardsData;
         //if (!this.lsDashboards.length || this.isPowerAdmin || this.isPowerUser || this.isAdminUser) {
            // this.dashboardList = result.data;
            dashboardsData = result.data;
         //} else {
            // this.dashboardList = result.data.filter(item => this.lsDashboards.includes(item.name));
            //dashboardsData = result.data.filter(item => this.lsDashboards.includes(item.name));
         //}

         // V260310: sorted the list
         this.dashboardList = sortArray(dashboardsData, 'name')

         if (ddl)
            this.selectedDashboard = this.dashboardList.find(item => item.name === ddl.name)?._id || '';
         else
            this.selectedDashboard = this.dashboardList.length ? this.dashboardList[isLocal ? 1 : 0]?._id : '';

         await this.dashboardChanged();
      },

      async dashboardChanged() {
         // this.log(`in dashboardChanged()...`);
         this.ddl = {};
         this.dashboard = {};
         this.ddlAuthor = '';

         if (!this.selectedDashboard) return;

         const result = await this.lsApiService.getDashboard(this.selectedDashboard);
         if (result.logout) this.logout();
         else if (result.message) {
            this.errMsg = result.message;
            return;
         }

         this.ddl = result.data;
         this.dashboard = JSON.parse(this.ddl.definition);
         this.ddlAuthor = this.ddl.author?.trim().toLowerCase() || '';
         this.allFiltersApplied = false;

         this.getDatePickers().forEach(dp => {
            dp.isApplied = false;
         });

         this.getDropdowns().forEach(dd => {
            dd.isApplied = true;
            dd.originalModel = deepClone(dd.filter.model);
         });

         this.dashboard.layout.forEach(layouts => {
            layouts.forEach(layout => {
               layout.originalModel = deepClone(layout.chart.model);
               layout.beforeClickModel = null;
            });
         });

         this.isDashboardEdited = false;
         this.originalDashboard = '';
         this.log(`dashboard=${JSON.stringify(this.dashboard)}`);
      },

      chartColorsChanged() {
         // alert(`in chartColorsChanged(): val=${val}`);
         if (!this.originalDashboard) {
            this.originalDashboard = this.getDashboardBasics();
            this.isDashboardEdited = true;
         } else
            this.isDashboardEdited = this.originalDashboard != this.getDashboardBasics();
      },

      editSwitchChanged(val) {
         if (val) {
            this.allFiltersApplied = false;
            this.dashboard.globalFilters.forEach(gf => {
               if (gf.filter.filterType === 'DatePicker') {
                  gf.isApplied = false;
               } else {
                  // gf.lastValue = null;
                  gf.isApplied = true;
               }
            });

            this.resetModels(this.dashboard);
            if (!this.originalDashboard) {
               this.originalDashboard = this.getDashboardBasics();
            }
         } else {
            this.getDropdowns().forEach(dd => {
               if (dd.lastValue && !dd.lastValue[dd.filter.model.column])
                  dd.lastValue = null;
            });

            this.isDashboardEdited = this.originalDashboard != this.getDashboardBasics();

            this.dashboard.globalFilters.forEach((gf, i) => {
               if (gf.filter.filterType === 'DatePicker') {
                  this.adjustModelsWithDate(gf.filter.dateColumn, i, gf.lastValue);
               } else {
                  this.adjustModelsWithDropdown(gf.filter.model.column, i, gf.lastValue?.length ? gf.lastValue : null);
               }
            });
         }
      },

      getDashboardBasics() {
         const oFilters = [];
         const oLayouts = [];

         this.dashboard.globalFilters.forEach(gf => {
            oFilters.push({
               cols: gf.cols,
               filter: gf.filter
            });
         });

         this.dashboard.layout.forEach(layouts => {
            const oLayout = [];

            layouts.forEach(layout => {
               oLayout.push({
                  cols: layout.cols,
                  chart: layout.chart,
                  chartColors: layout.chartColors
               })
            });

            oLayouts.push(oLayout);
         });

         return sortedStringify({
            chartColors: this.dashboard.chartColors,
            globalFilters: oFilters,
            layout: oLayouts
         });
      },

      getFiltersSumCols() {
         const sum = this.dashboard.globalFilters.reduce((sum, item) => {
            return sum + Number(item.cols || 0);
         }, 0);
         return sum;
      },

      getChartsSumCols(rIndex) {
         const sum = this.dashboard.layout[rIndex].reduce((sum, item) => {
            return sum + Number(item.cols || 0);
         }, 0);
         return sum;
      },

      // async generatePdf() {
      //    this.disableTransitions = true;
      //    await this.$nextTick(); // ensure DOM updates
      //    await html2pdf()
      //       .from(document.getElementById("element-to-convert"))
      //       .set({
      //          margin: 0.1,
      //          filename: 'list-service-dashboard.pdf',
      //          image: { type: 'jpeg', quality: 0.98 },
      //          html2canvas: { scale: 1 },
      //          pagebreak: { mode: 'avoid-all' },
      //          jsPDF: { unit: 'in', format: 'letter', orientation: 'l' }
      //       })
      //       .save();

      //    this.$emit('snackbar-event', `The PDF was successfully generated.`);
      //    this.disableTransitions = false;
      // },

      async generatePdf() {
         const icons = document.querySelectorAll('.v-icon');
         icons.forEach(i => {
            i.setAttribute('data-original', i.innerHTML);
            i.innerHTML = i.textContent; // use the ligature / text form
         });

         const wrapper = document.querySelector('.pdf-wrapper');
         wrapper.classList.add('pdf-mode'); // disable transitions

         await html2pdf()
            .from(wrapper)
            .set({
               margin: 0.5,
               filename: 'lake-service-dashboard.pdf',
               image: { type: 'jpeg', quality: 0.98 },
               html2canvas: { scale: 1 },
               pagebreak: { mode: 'avoid-all' },
               jsPDF: { unit: 'in', format: 'letter', orientation: 'l' }
            })
            .save();

         wrapper.classList.remove('pdf-mode'); // restore transitions
         this.$emit('snackbar-event', `The PDF was successfully generated.`);

         icons.forEach(i => {
            if (i.dataset.original) i.innerHTML = i.dataset.original;
         });
      },

      async saveNewDashboard(ddlObject) {
         ddlObject.definition = JSON.stringify({
            globalFilters: [ new GlobalFilter() ],
            layout: [[ new Layout() ]],
            chartColors: this.chartColorsItems[1].value
         });

         const result = await this.lsApiService.createDashboard(ddlObject);
         if (result.logout) {
            this.logout();
         } else if (result.message) {
            this.errMsg = result.message;
         } else {
            this.getDashboards(ddlObject);
            this.ddlNew = {};
         }
      },

      dashboardCreated(ddlObject) {
         this.$emit('snackbar-event', `'${ddlObject.name}' was successfully created.`);
      },

      async saveDashboard(ddlObject) {
         // delete this.dashboard.globalFilters[0].filterData;
         // delete this.dashboard.globalFilters[0].lastValues;

         // delete this.dashboard.layout[0][0].chartData;
         // delete this.dashboard.layout[0][0].chart.filter;
         // delete this.dashboard.layout[1][0].chartData;


         // this.dashboard.layout[0][0].chart.model.whereClause = '';
         // this.dashboard.layout[0][1].chart.model.whereClause = "where product in ('Product1', 'Product2')";
         // this.dashboard.layout[0][2].chart.model.whereClause = 'where price < 1000000';
         // this.dashboard.layout[1][0].chart.model.whereClause = 'where price >= 1500';

         // this.dashboard.globalFilters[1].filter.model.whereClause = '';

         // this.dashboard.layout.forEach(layouts => {
         //    layouts.forEach(layout => {
         //       delete layout.slicedWhereClause;
         //       delete layout.slicedData;
         //    });
         // });

         /* V260323 - start */
         let metricsCnt = 0;
         let errCnt = 0;
         const { maxDashboardMetrics, maxChartMetrics } = this.dashboardsSettings;
         this.dashboard.layout.forEach(layouts => {
            layouts.forEach(layout => {
               const len = layout.chart.model.metrics?.length || 1;
               metricsCnt += len;
               if (len > maxChartMetrics) {
                  errCnt++;
                  layout.errorMessage = `Number of metrics must be <= ${maxChartMetrics}!`;
               } else layout.errorMessage = '';
            });
         });

         if (errCnt) {
            // this.errMsg = `Your changes were not saved. We found ${errCnt} cells that exceeded their max number of metrics. Please fix the issues and try again.`;
            this.errMsg = `UPDATE FAILED: ${errCnt} cell${errCnt > 1 ? 's' : ''} exceed their metrics limit. Please resolve these errors and try again.`;
            return;
         }
         if (metricsCnt > maxDashboardMetrics) {
            this.errMsg = `UPDATE FAILED: Your dashboard exceeds the total limit of ${maxDashboardMetrics} metrics. Please remove ${metricsCnt - maxDashboardMetrics} metrics and try again.`;
            return;
         }

         this.errMsg = '';
         /* V260323 - end */

         this.ddl.definition = JSON.stringify(this.dashboard);
         // const dashToSave = deepClone(this.dashboard);
         // this.cleanDashboard(dashToSave);
         const dashToSave = this.cleanDashboard();
         ddlObject.definition = JSON.stringify(dashToSave);
         const result = await this.lsApiService.updateDashboard(ddlObject);
         if (result.logout) this.logout();
         else if (result.message) this.errMsg = result.message;
         else {
            this.isDashboardEdited = false;
            this.originalDashboard = '';
         }
      },

      dashboardSaved(ddlObject) {
         this.$emit('snackbar-event', `'${ddlObject.name}' was successfully saved.`);
      },

      async saveAsDashboard(ddlObject) {
         this.ddl.definition = JSON.stringify(this.dashboard);

         // const dashToSave = deepClone(this.dashboard);
         // this.cleanDashboard(dashToSave);
         const dashToSave = this.cleanDashboard();
         ddlObject.definition = JSON.stringify(dashToSave);
         delete ddlObject._id;

         const result = await this.lsApiService.createDashboard(ddlObject);
         if (result.logout) this.logout();
         else if (result.message) this.errMsg = result.message;
         else this.getDashboards(ddlObject);
      },

      async deleteDashboard(ddlObject) {
         const result = await this.lsApiService.deleteDashboard(ddlObject._id);
         if (result.logout) this.logout();
         else if (result.message) this.errMsg = result.message;
         else this.getDashboards(); //param is not required
      },
      
      dashboardDeleted(ddlObject) {
         this.$emit('snackbar-event', `'${ddlObject.name}' was successfully deleted.`);
      },

      discardChanges() {
         if (confirm('This will revert the dashboard to its last saved version.\nAre you sure?')) {
            this.dashboard = JSON.parse(this.ddl.definition);//TODO: call dashboardChanged()?
            this.isDashboardEdited = false;
            this.originalDashboard = '';
            this.$emit('snackbar-event', 'The dashboard has been reverted to the last saved version.');
         }
      },

      /* dash is changed in the func */
      resetModels(dash) {
         this.getDropdowns(dash).forEach(dd => {
            if (dd.originalModel) {
               dd.slicedData = dd.filter.model.whereClause;
               dd.filter.model = dd.originalModel;
            }
         });

         dash.layout.forEach(layouts => {
            layouts.forEach(layout => {
               if (layout.originalModel) {
                  if (layout.chart.model?.type?.endsWith('-metrics'))
                     layout.slicedData = JSON.stringify(layout.chart.model);
                  else
                     layout.slicedData = layout.chart.model.whereClause;

                  layout.chart.model = layout.originalModel;
               }

               layout.beforeClickModel = null;
            });
         });
      },

      cleanDashboard() {
         const dashOut = deepClone(this.dashboard);
         // console.warn('in cleanDashboard(): dashboardIn=' + JSON.stringify(this.dashboard));
         
         delete dashOut.originalModelsSaved; //TODO: only once after saving all dashboards
         this.getDropdowns(dashOut).forEach(dd => {
            delete dd.beforeClickModel;
            delete dd.slicedData;
            delete dd.slicedWhereClause;  //TODO: only once after saving all dashboards
            delete dd.chartOptions;       //TODO: only once after saving all dashboards
            if (dd.originalModel) {
               dd.filter.model = dd.originalModel;
               delete dd.originalModel;
            }
         });

         dashOut.layout.forEach(layouts => {
            layouts.forEach(layout => {
               delete layout.beforeClickModel;
               delete layout.slicedData;
               delete layout.slicedWhereClause; //TODO: only once after saving all dashboards
               delete layout.chartOptions;      //TODO: only once after saving all dashboards
               if (layout.originalModel) {
                  layout.chart.model = layout.originalModel;
                  delete layout.originalModel;
               }
            });
         });

         // console.warn('in cleanDashboard(): dashOut=' + JSON.stringify(dashOut));
         return dashOut;
      },

      gfSaved() { //currGf, currInd
         // currGf.canEditType = false;
      },

      gfModelChanged(currGf, currInd) {
         // this.isDashboardValid = true;
         currGf.data = [];
         currGf.isApplied = currGf.filterType === 'Dropdown';

         this.dashboard.globalFilters.forEach((gf, i) => {
            if (gf.filter.filterType === 'Dropdown') {
               if (i === currInd)
                  currGf.originalModel = deepClone(currGf.filter.model);

               const gfColumn = gf.filter.model.column;
               if (!gfColumn)
                  gf.errorMessage = 'model.column should have value!';
               else if (i != currInd && gfColumn === currGf.filter.model.column)
                  gf.errorMessage = `'${gfColumn}' is a duplicate column!`;
               else
                  gf.errorMessage = '';
            } else {
               const gfDateColumn = gf.filter.dateColumn;
               if (!gfDateColumn)
                  gf.errorMessage = 'Date Column is required!';
               else {
                  if (i != currInd && gfDateColumn === currGf.filter.dateColumn) {
                     gf.errorMessage = `'${gfDateColumn}' is a duplicate Date Column!`;
                  } else {
                     gf.errorMessage = '';
                     this.dashboard.layout.forEach(layouts => {
                        layouts.forEach(layout => {
                           if (layout.chart.model?.whereClause?.toLowerCase().includes(' ' + gfDateColumn)) {
                              layout.errorMessage = `where-clause cannot contain a condition for '${gfDateColumn}'!`;
                              // this.isDashboardValid = false;
                           } else {
                              layout.errorMessage = '';
                           }
                        });
                     });
                  }
               }
            }

            // if (gf.errorMessage)
            //    this.isDashboardValid = false;
         });

         // // this.checkChartsAgainstFilters();//TODO: check specific filter against all charts
      },

      dateChanged(dateColumn, index, val, id) {
         // this.log(`in dateChanged(): dateColumn=${dateColumn}, val=${JSON.stringify(val)}, id=${id}`);
         // this.lastDatePickerId = id;
         this.dashboard.globalFilters[index].lastId = id;
         this.dashboard.globalFilters[index].lastValue = val;
         this.adjustModelsWithDate(dateColumn, index, val);
      },

      adjustModelsWithDate(dateColumn, index, val) {
         // if (this.isEditing) return;
         // this.log(`in adjustModelsWithDate(): dateColumn=${dateColumn}, val=${JSON.stringify(val)}`);
         
         this.dashboard.globalFilters[index].isApplied = true;
         this.allFiltersApplied = this.dashboard.globalFilters.every(gf => gf.isApplied);

         this.getDropdowns().forEach(gf => {
            const { model } = gf.filter;
            if (val && !gf.errorMessage) {
               gf.filter.model = this.adjustModel(
                  gf.originalModel || model,
                  model,
                  val,
                  dateColumn
               );
            }
         });

         this.dashboard.layout.forEach(layouts => {
            layouts.forEach(layout => {
               const { model } = layout.chart;
               if (val && !layout.errorMessage) {
                  layout.chart.model = this.adjustModel(
                     layout.originalModel || model,
                     model,
                     val,
                     dateColumn
                  );
               }
            });
         });
      },

      dropdownChanged(column, index, val) {
         // this.log(`in dropdownChanged(): index=${index}, val=${JSON.stringify(val)}`);
         if (this.isEditing) return;

         this.dashboard.globalFilters[index].lastValue = val[column]?.length ? val : null; //To also keep the switch value[column];//TODO:
         this.adjustModelsWithDropdown(column, index, val);
      },

      adjustModelsWithDropdown(column, index, val) {
         // this.log(`in adjustModelsWithDropdown(): column=${column}, index=${index}, val=${JSON.stringify(val)}`);
         this.dashboard.globalFilters[index].isApplied = true;
         this.allFiltersApplied = this.dashboard.globalFilters.every(gf => gf.isApplied);

         if (!val) return;

         this.getDropdowns().forEach(dd => {
            if (dd.filter.model.column === column || dd.errorMessage)
               return;

            dd.filter.model = this.adjustModel(
               dd.originalModel,
               dd.filter.model,
               val
            );
         });

         this.dashboard.layout.forEach(layouts => {
            layouts.forEach(layout => {
               const chart = layout.chart;
               // if (chart.chartType) {
                  chart.model = this.adjustModel(
                     layout.originalModel,
                     chart.model,
                     val
                  );
               // }
            });
         });
      },

      dropdownDataChanged(index, val) {
         this.dashboard.globalFilters[index].data = val;
      },

      /*
       * clickData: { columns: [], data: [], filter (optional): '', exclude (optional): false | true }
       */
      chartClicked(rowIndex, colIndex, clickData) {
         // alert(`in ${NAME}.chartClicked(): rowIndex=${rowIndex}, colIndex=${colIndex}\nclickData=${JSON.stringify(clickData)}`);
         this.dashboard.layout.forEach((layouts, i) => {
            layouts.forEach((layout, j) => {
               if (layout.errorMessage || (i === rowIndex && j === colIndex))
                  return;

               const chart = layout.chart;
               // // // if (!chart.chartType) return;

               if (!layout.beforeClickModel) {
                  layout.beforeClickModel = deepClone(chart.model);
               }

               const model = layout.beforeClickModel;
               const whereClause = model.whereClause?.trim()?.toLowerCase();

               //NOTE: Injecting dropdown selection only in models that has no dependencies on colName
               // if (
               //       clickData.columns.includes(model.pivotDim) ||
               //       clickData.columns.some(col => whereClause.includes(col))
               //    ) return;

               const clickedKeyVal = [];
               clickData.columns.forEach((col, k) => {
                  if (col != model.pivotDim && !whereClause?.includes(col))
                     clickedKeyVal.push(clickData.data[k]);
               });

               // V260223: was modified
               if (clickedKeyVal.length) {
                  const prefix = model.whereClause ? model.whereClause + ' and ' : 'where ';
                  // chart.model.whereClause = prefix + clickedKeyVal.join(' and ');
                  // if (clickData.filter) {
                  //    chart.model.whereClause += ' and ' + clickData.filter.slice(6);
                  // }
                  
                  let exclude;
                  if (chart.chartType === 'PaginatedTable') {
                     chart.model.lake.year = '*';
                     chart.model.lake.month = '*';
                     exclude = clickData.exclude;
                  }

                  // V260313
                  const hasFilter = model.metrics?.filter(m => m.filter?.trim()).length > 0;
                  const hasWhere = !!whereClause && !/^\s*where\s+event_date\s+between\s+'[^']+'\s+and\s+'[^']+'\s*$/i.test(whereClause);

                  chart.model.whereClause = _mergeWhereAndFilter(
                     prefix + clickedKeyVal.join(' and '),
                     hasFilter || hasWhere ? '' : clickData.filter,
                     exclude
                  );
               }

               this.log(`in chartClicked(): whereClause=${chart.model.whereClause}`);
            });
         });
      },

      adjustModel(originalModel, modelIn, adjustingModel, dateColumn) {
         // this.log(`in adjustModel(): originalModel=${JSON.stringify(originalModel)}\nmodelIn=${JSON.stringify(modelIn)}\nadjustingModel=${JSON.stringify(adjustingModel)}, dateColumn=${dateColumn}`);
         const modelOut = deepClone(modelIn);
         const clause = (modelOut.whereClause || '').trim();         
         let pattern, partialClause;

         if (dateColumn) {
            let hasExclude;
            if (dateColumn === 'event_date') {
               hasExclude = modelOut.metrics?.some(item => item.exclude === true);
               pattern = '';
               partialClause = '';
            } else {
               pattern = '\\s+and\\s+';
               partialClause = ' and ';
            }

            pattern += `${dateColumn}\\s+between\\s+'[^']+'\\s+and\\s+'[^']+'`

            const fromDate = getUTCFromDate(adjustingModel[0], this.dashboardsSettings.timezone);
            const toDate = getUTCToDate(adjustingModel[1], this.dashboardsSettings.timezone);
            partialClause += `${dateColumn} between '${fromDate}' and '${toDate}'`;

            if (hasExclude) {
               const includedMetrics = modelOut.metrics.filter(m => !m.exclude);
               if (includedMetrics.length) {
                  includedMetrics.forEach(metric => {
                     metric.filter = this.adjustClause(metric.filter, pattern, partialClause, dateColumn);
                  });
                  
                  modelOut.lake.year = '*';
                  modelOut.lake.month = '*';
               }

               return modelOut;
            }
			
            // V260203
            const adjustedLake = this.dateRangeChanged(fromDate, toDate);  //V260320: adjustingModel
            if (adjustedLake)
               modelOut.lake = adjustedLake;
         } else { //dropdown-change
            const colName = Object.keys(adjustingModel)[1];

            //NOTE: Injecting dropdown selection only in models that has no dependencies on colName
            if (colName === originalModel.pivotDim ||
               originalModel.whereClause?.includes(colName)
            ) return modelIn;

            //V260223: pattern = `\\s+and\\s+${colName}\\s+(?:not\\s+in|in)\\s*\\([^)]*\\)`;
            pattern = `(?:\\s+and\\s+|where\\s+)${colName}\\s+(?:not\\s+in|in)\\s*\\([^)]*\\)`;
            const colVal = adjustingModel[colName];
            if (colVal.length) {
               const operator = adjustingModel.$dropdownSwitch ? 'in' : 'not in';
               const values = colVal.map(item => `'${item}'`).join(',');
               partialClause = ` and ${colName} ${operator} (${values})`;
            } else {
               partialClause = '';
            }
         }

         modelOut.whereClause = this.adjustClause(clause, pattern, partialClause, dateColumn);

         // this.log(`modelOut.whereClause=${JSON.stringify(modelOut.whereClause)}`);
         return modelOut;
      },

      // V260203
      // V260320: replaced val param
      dateRangeChanged(fromDate, toDate) {
         // alert(`in dateRangeChange(): val=${JSON.stringify(val)}`);
         // this.fromDate = getUTCFromDate(val[0], this.chartsSettings.timezone);
         // this.toDate = getUTCToDate(val[1], this.chartsSettings.timezone);
         const fromParts = fromDate.split('-');
         const toParts = toDate.split('-');
         const fromYear = fromParts[0];
         const toYear = toParts[0];
         const fromMonth = fromParts[1].replace(/^0/, '');
         const toMonth = toParts[1].replace(/^0/, '');
         const lakeYear = [];

         for (let year = +fromYear; year <= +toYear; year++) {
            const startMonth = year === +fromYear ? +fromMonth : 1;
            const endMonth = year === +toYear ? +toMonth : 12;

            for (let month = startMonth; month <= endMonth; month++) {
               lakeYear.push(`${year}/${month}`);
            }
         }

         const parquetAvailability = this.splitParquetAvailability(lakeYear);
         const availableLakeYears = Array.from(parquetAvailability.withParquet);
         if (availableLakeYears.length) {
            return {
               year: availableLakeYears.join(','),
               month: '|',
               fileFormat: 'parquet'
            };
         } else return null;
      },

      // V260203
      splitParquetAvailability(monthPaths) {
         const withParquet = [];
         const withoutParquet = [];

         for (const ym of monthPaths) {
            if (this.parquetFilesSet.has(ym)) {
               withParquet.push(ym);
            } else {
               withoutParquet.push(ym);
            }
         }

         return { withParquet, withoutParquet };
      },	  

      adjustClause(clauseIn, pattern, partialClause, dateColumn) {
         let clauseOut;
         if (clauseIn) {
            const regex = new RegExp(pattern, 'i');
            if (regex.test(clauseIn)) {
               //V260223: clauseOut = clauseIn.replace(regex, partialClause);
               const tempClause = clauseIn.replace(regex, partialClause);
               clauseOut = `${tempClause.startsWith(' and ') ? ('where ' + tempClause.slice(5)) : tempClause}`;
            } else if (dateColumn === 'event_date') {
               clauseOut = clauseIn.replace(
                  /where\s+/i,
                  `where ${partialClause} and `
               );
            } else {
               clauseOut = `${clauseIn}${partialClause}`;
            }
         } else {
            //V260223: clauseOut = 'where ' + partialClause;
            clauseOut = `where ${partialClause.startsWith(' and ') ? partialClause.slice(5) : partialClause}`;
         }

         return clauseOut;
      },

      chartReclicked(row, col) {
         this.dashboard.layout.forEach((layouts, i) => {
            layouts.forEach((layout, j) => {
               if ((i != row || j != col) && layout.beforeClickModel) {
                  layout.chart.model = layout.beforeClickModel;
                  layout.beforeClickModel = null;
               } 
            });
         });
      },

      chartModelChanged(layout) {
         //TODO: check if when a new chart is added

         layout.data = [];
         layout.originalModel = deepClone(layout.chart.model);
         layout.beforeClickModel = null;

         // // this.checkChartsAgainstFilters();//TODO: check specific chart against all filters
         this.getDatePickers().forEach(gf => {
            const { dateColumn } = gf.filter;
            if (dateColumn && layout.chart.model?.whereClause?.toLowerCase().includes(' ' + dateColumn)) {
               layout.errorMessage = `where-clause cannot contain a condition for '${dateColumn}'!`;
               // this.isDashboardValid = false;
            } else {
               layout.errorMessage = '';
            }
         });
      },

      // // checkChartsAgainstFilters() {
      // //    this.dashboard.globalFilters.forEach((gf, i) => {
      // //       const colName = gf.filter.filterType === 'Dropdown'
      // //       ? gf.filter.model.column : gf.filter.dateColumn;

      // //       this.dashboard.layout.forEach(layouts => {
      // //          layouts.forEach(layout => {
      // //             if (layout.chart.model?.whereClause?.toLowerCase().includes(' ' + colName)) {
      // //                layout.errorMessage = `where-clause cannot contain a condition for '${colName}'!`;
      // //                this.isDashboardValid = false;
      // //             } else
      // //                layout.errorMessage = '';
      // //          });
      // //       });
      // //    });
      // // },

      resetFilterColSizes() {
         if (12 - this.getFiltersSumCols() >= this.minFilterColSize)
            return;

         const len = this.dashboard.globalFilters.length;
         let newCols = 0;
         if (len === 3 || len === 4)
            newCols = 12 / len;

         if (newCols) {
            this.dashboard.globalFilters.forEach(gf => {
               gf.cols = newCols;
            });
         }
      },
      
      filter_delete(index) {
         //TODO: add confirm()
         // alert('in filter_delete:' + index)
         this.dashboard.globalFilters.splice(index, 1);
         // this.resetFilterColSizes();
      },

      filter_copy(index) {
         // alert('in filter_copy:' + index)
         // const filterToCopy = this.dashboard.globalFilters[index];
         // const copiedFilter = JSON.parse(JSON.stringify(filterToCopy));
         // if (copiedFilter.filter.filterType === 'Dropdown') {
         //    copiedFilter.filter.title += ' Copy';
         // }
         // this.dashboard.globalFilters.splice(index, 0, copiedFilter);

         this.resetFilterColSizes();

         const filterToCopy = deepClone(this.dashboard.globalFilters[index]);
         // const filterToCopy = { ...this.dashboard.globalFilters[index] };
         if (filterToCopy.filter.title) {
            filterToCopy.filter.title += ' Copy';
         }

         if (filterToCopy.filter.filterType === 'DatePicker') {
            filterToCopy.filter.dateColumn = '';
         } else {
            filterToCopy.filter.model.column = '';
         }

         this.dashboard.globalFilters.splice(index + 1, 0, filterToCopy);

         this.gfModelChanged(filterToCopy, index + 1);
      },

      filter_add(index) {
         // const sumCols = this.dashboard.globalFilters.reduce((sum, item) => {
         //    return sum + Number(item.cols || 0);
         // }, 0);
         // const newCols = (12 - this.gfSumCols) > 4 ? 4 : 12 - this.gfSumCols;
         // const newCols = (12 - this.gfSumCols) > this.minFilterColSize ? 4 : this.minFilterColSize;
         // let colsTot = 0;
         // this.dashboard.globalFilters.forEach(gf => {
         //    colsTot += gf.cols;
         // });
         
         this.resetFilterColSizes();
         const colsTot = this.getFiltersSumCols();
         const newCols = (12 - colsTot) > this.minFilterColSize ? 4 : this.minFilterColSize;
         this.dashboard.globalFilters.push(new GlobalFilter(newCols, index + 1));
      },

      filter_left(index) {
         const gf = this.dashboard.globalFilters;
         [gf[index], gf[index - 1]] = [gf[index - 1], gf[index]];
      },

      filter_right(index) {
         const gf = this.dashboard.globalFilters;
         [gf[index], gf[index + 1]] = [gf[index + 1], gf[index]];
      },

      cell_delete(rIndex, cIndex) {
         this.dashboard.layout[rIndex].splice(cIndex, 1);
         if (this.dashboard.layout[rIndex].length === 0) {
            this.dashboard.layout.splice(rIndex, 1);
         }
      },

      cell_copy(rIndex, cIndex) {
         const temp = this.dashboard.layout[rIndex][cIndex];
         this.dashboard.layout[rIndex].splice(cIndex, 0, deepClone(temp));
      },

      async cell_add(rIndex) {
         const sumCols = this.dashboard.layout[rIndex].reduce((sum, item) => {
         return sum + Number(item.cols || 0);
         }, 0);
         const newCols = (12 - sumCols) >= 4 ? 12 - sumCols : 4;
         this.dashboard.layout[rIndex].push(new Layout(newCols));
      },

      async cell_left(rIndex, cIndex) {
         const row = this.dashboard.layout[rIndex];
         [row[cIndex], row[cIndex - 1]] = [row[cIndex - 1], row[cIndex]];
      },

      async cell_right(rIndex, cIndex) {
         const row = this.dashboard.layout[rIndex];
         [row[cIndex], row[cIndex + 1]] = [row[cIndex + 1], row[cIndex]];
      },

      cell_down(rIndex, cIndex) {
         const [cell] = this.dashboard.layout[rIndex].splice(cIndex, 1);
         this.dashboard.layout[rIndex + 1].push(cell);
      },

      cell_up(rIndex, cIndex) {
         const [cell] = this.dashboard.layout[rIndex].splice(cIndex, 1);
         this.dashboard.layout[rIndex - 1].push(cell);
      },

      cell_return() {
         this.dashboard.layout.push([ new Layout() ]);
      },

      exportCreated(val) {
         this.$emit('snackbar-event', val);
      },

      async getImportHeaders(resolve) {
         if (!this.importHeaders.length) {
            this.importHeaders = await this.btHelpers.getImportHeaders(this.btHelpers.getInitialFilter());
         }
         resolve(this.importHeaders);
      },

      getDatePickers() {
         return this.dashboard.globalFilters.filter(gf => gf.filter.filterType === 'DatePicker');
      },

      getDropdowns(dash) {
         if (dash === undefined)
            dash = this.dashboard;

         return dash.globalFilters.filter(gf => gf.filter.filterType === 'Dropdown');
      },

      getDefaultDateRange(defaultId) {
         // alert(`in getDefaultDateRange(): val=${defaultId}`);
         var today = new Date();
         var fd;
         var td;

         switch (defaultId) {
            case 'CR':
               return null;
            case "TM": //from first day of this month till today
               fd = startOfMonth(today);
               break;
            case "LM": //from first to last day of previous month
               var lm = addMonths(today, -1);
               fd = startOfMonth(lm);
               td = endOfMonth(lm);
               break;
            default:
               fd = startOfDay(addDays(today, -parseInt(defaultId)));
               break;
         }

         if (!td) td = today;

         return [format(fd, 'yyyy-MM-dd'), format(td, 'yyyy-MM-dd')];
      },

      getDatePickerColumns(currFilter) {
         const datePickers = this.dashboard.globalFilters.filter(gf => gf.filter.filterType === 'DatePicker');
         const remainingFields = [];
         this.dateColumns.forEach(col => {
            if (col === currFilter.dateColumn || !datePickers.filter(dp => dp.filter.dateColumn === col).length)
               remainingFields.push(col);
         });

         return remainingFields;
      },

      // V260320
      async getSettings() {
         const result = await this.lsApiService.getSettings();
         //V260323: this.dashboardsSettings = result.data?.dashboards || {};
         this.dashboardsSettings = {
            maxDashboardMetrics: 15,
            maxChartMetrics: 10,
            ...(result.data?.dashboards || {})
         };
      }
   },

   created() {}
}
</script>

<style scoped>
.pdf-wrapper.pdf-mode * {
   transition: none !important;
   animation: none !important;
}
</style>